
(() => {
  const initCarousel = (scope = document) => {
    scope.querySelectorAll('[data-lf-carousel-root]').forEach((root) => {
      if (root.dataset.lfCarouselInitialized === 'true') return;

      const track = root.querySelector('[data-lf-carousel-track]');
      const cards = Array.from(root.querySelectorAll('[data-lf-carousel-card]'));
      const prev = root.querySelector('[data-lf-carousel-prev]');
      const next = root.querySelector('[data-lf-carousel-next]');

      if (!track || !cards.length) return;

      root.dataset.lfCarouselInitialized = 'true';

      let activeIndex = 0;
      let ticking = false;
      let dragging = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;

      const setActive = () => {
        ticking = false;
        const rect = track.getBoundingClientRect();
        const center = rect.left + rect.width / 2;

        let nearestIndex = 0;
        let nearestDistance = Infinity;

        cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + cardRect.width / 2;
          const delta = cardCenter - center;
          const distance = Math.abs(delta);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }

          const normalized = delta / Math.max(rect.width, 1);
          const amount = Math.min(Math.abs(normalized), 1);
          const rotate = Math.max(-14, Math.min(14, normalized * -28));
          const scale = 1 - amount * 0.09;
          const opacity = 1 - amount * 0.28;
          const z = 36 - amount * 36;

          card.style.setProperty('--lf-book-rotate', rotate.toFixed(2) + 'deg');
          card.style.setProperty('--lf-book-scale', scale.toFixed(3));
          card.style.setProperty('--lf-book-opacity', opacity.toFixed(3));
          card.style.setProperty('--lf-book-z', z.toFixed(1) + 'px');
        });

        activeIndex = nearestIndex;
        cards.forEach((card, index) => {
          card.classList.toggle('is-active', index === activeIndex);
          card.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
      };

      const requestSetActive = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(setActive);
      };

      const goTo = (index, behavior = 'smooth') => {
        const wrapped = (index + cards.length) % cards.length;
        const card = cards[wrapped];
        const left = card.offsetLeft - ((track.clientWidth - card.offsetWidth) / 2);

        track.scrollTo({
          left: Math.max(0, left),
          behavior
        });

        activeIndex = wrapped;
        cards.forEach((c, i) => c.classList.toggle('is-active', i === wrapped));
      };

      if (prev) {
        prev.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          goTo(activeIndex - 1);
        };
      }

      if (next) {
        next.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          goTo(activeIndex + 1);
        };
      }

      cards.forEach((card, index) => {
        card.onclick = (e) => {
          if (e.target.closest('a, button, input, form')) return;
          if (moved) return;

          if (index !== activeIndex) {
            goTo(index);
            return;
          }

          const url = card.dataset.productUrl;
          if (url) window.location.assign(url);
        };
      });

      track.addEventListener('scroll', requestSetActive, { passive: true });
      window.addEventListener('resize', requestSetActive, { passive: true });

      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      track.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 5) moved = true;
        track.scrollLeft = startScroll - dx;
      });

      const stopDrag = () => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        requestSetActive();
        setTimeout(() => { moved = false; }, 0);
      };

      track.addEventListener('pointerup', stopDrag);
      track.addEventListener('pointercancel', stopDrag);
      track.addEventListener('pointerleave', stopDrag);

      setActive();
    });
  };

  const boot = () => initCarousel(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCarousel(event.target || document);
  });

  document.addEventListener('shopify:section:reorder', boot);
})();

